import React, { useContext } from 'react';
import Faq from './Faq';
import ConfigContext from '../../../contexts/ConfigContext';

const getTacoFaqQuestions = (cityName, siteTitle, vehicleType) => [
  {
    question: `How much does taco food ${vehicleType} catering cost in ${cityName}?`,
    answer: `Taco food ${vehicleType} catering costs in ${cityName} depend on guest count, menu style, and service length. Smaller private events often start around a few hundred dollars, while larger corporate events, weddings, and festivals may range higher. ${siteTitle} lets you compare real quotes from taco food ${vehicleType}s so you can find great food that fits your budget, with clear pricing and no hidden fees.`
  },
  {
    question: `What types of tacos can a taco food ${vehicleType} serve at my event?`,
    answer: `Taco food ${vehicleType}s offer a wide variety of options, including classic street tacos like carne asada and al pastor, Baja-style fish tacos, vegetarian and vegan tacos, and creative fusion flavors. Many taco ${vehicleType}s also provide house-made salsas, fresh tortillas, and customizable taco bars, making it easy to tailor the menu to your event.`
  },
  {
    question: `Are taco food ${vehicleType}s good for weddings and large events?`,
    answer: `Yes — taco food ${vehicleType}s are one of the most popular catering options for weddings, corporate events, and large gatherings. Tacos are easy to serve, crowd-friendly, and customizable for different dietary needs. Many couples choose taco ${vehicleType}s for wedding receptions, rehearsal dinners, and late-night snacks because they're fun, flavorful, and memorable.`
  },
  {
    question: `Can taco food ${vehicleType}s accommodate vegetarian, vegan, or gluten-free diets?`,
    answer: `Most taco food ${vehicleType}s offer vegetarian and vegan taco options, and many can accommodate gluten-free requests using corn tortillas and alternative fillings. When submitting your catering request, you can note any dietary needs, and ${siteTitle} will match you with taco ${vehicleType}s that can meet your guests' preferences.`
  },
  {
    question: `How far in advance should I book a taco food ${vehicleType} for catering?`,
    answer: `For best availability, we recommend booking a taco food ${vehicleType} 3–6 weeks in advance, especially for weddings, summer events, and corporate catering. However, last-minute taco catering may be possible depending on availability. Submitting your request early gives you the most menu options and scheduling flexibility.`
  }
];

function TacoFaq() {
  const { city_name, site_title, vehicle_type } = useContext(ConfigContext);
  const vehicleType = vehicle_type.toLowerCase();

  const questions = getTacoFaqQuestions(city_name, site_title, vehicleType);

  return (
    <Faq questions={questions} />
  );
}

export default TacoFaq;
